export default __webpack_public_path__ + "static/bg-3-3e4aa76b673bb8bab877e3123fbae9d4.png";